module.exports = __webpack_public_path__ + "static/media/calm-waters.333893d9.jpg";